module.exports = __webpack_public_path__ + "static/media/11-5.d3a2b069.mp3";